/* eslint-disable @typescript-eslint/ban-types */
import React, { createContext, useCallback, useContext, useState } from 'react';
import ICredential from '../dtos/ICredential';
import api from '../services/api';

// só as que serão usadas fora

interface AuthState {
  token: string;
  credential: ICredential;
}

interface SignInCredentials {
  email: string;
  password: string;
}

interface AuthContextData {
  credential: ICredential;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('@data-manager:Token');
    const credential = localStorage.getItem('@data-manager:Credential');

    if (token && credential) {
      api.defaults.headers.authorization = `Bearer ${token}`;
      return { token, credential: JSON.parse(credential) };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ email, password }) => {
    const responseSessions = await api.post('sessions', { email, password });
    const { token, user } = responseSessions.data;
    api.defaults.headers.authorization = `Bearer ${token}`;


    const credential: ICredential = {
      user,
      permissions: user.id===1? 'admin': 'normal',
    }
    localStorage.setItem('@data-manager:Token', token);
    localStorage.setItem('@data-manager:Credential', JSON.stringify(credential));


    setData({ token, credential });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@data-manager:Token');
    localStorage.removeItem('@data-manager:Credential');
    setData({} as AuthState);
  }, []);



  return (
    <AuthContext.Provider
      value={{ credential: data.credential, signIn, signOut }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);
  return context;
}
